var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTagManager(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "871.19mm",
    height: "871.34mm",
    viewBox: "0 0 2469.53 2469.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1449.81,2376.05,1021,1946.75l921.1-930.5,436.7,436.6Z",
    transform: "translate(0 0)",
    style: {
      fill: "#8ab4f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1452.91,527.15l-436.6-436.7-925.8,925.8c-120.6,120.5-120.7,315.8-.2,436.4l.2.2,925.8,925.8,428.3-430.3L745,1235.15Z",
    transform: "translate(0 0)",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2378.71,1016.25l-925.8-925.8c-120.6-120.6-316.1-120.6-436.7,0s-120.6,316.1,0,436.6l926.3,925.8c120.6,120.6,316.1,120.6,436.6,0s120.6-316.1,0-436.6Z",
    transform: "translate(0 0)",
    style: {
      fill: "#8ab4f8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1231.21,
    cy: 2163.95,
    r: 306,
    style: {
      fill: "#246fdb"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagManager);
export default __webpack_public_path__ + "static/media/tag-manager.7a95f7f9fbdafddf51be5ee0a67c5d2e.svg";
export { ForwardRef as ReactComponent };